export default __webpack_public_path__ + "static/media/arrow-left.a9aa53a5.svg";